<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="push" side="start" #mymenu>
      <ion-content>
        <ion-list id="inbox-list">
          <ion-list-header>Menu </ion-list-header>
          <ion-note>Hi</ion-note>

          <ion-menu-toggle
            auto-hide="false"
            *ngFor="let p of appPages; let i = index"
          >
            <ion-item
              (click)="selectedIndex = i"
              routerDirection="root"
              [routerLink]="[p.url]"
              lines="none"
              detail="false"
              [class.selected]="selectedIndex == i"
              *ngIf="
                p.type === 'admin'
                  ? (user | async)?.role === 'admin' && !user?.uid
                  : true || p.url === '/home'
                  ? (user | async)?.role === 'medical_personnel' ||
                    ((user | async)?.role === 'volunteer_maker' && !user?.uid)
                  : true
              "
            >
              <span class="emoji">
                {{ p.icon }}
              </span>
              <ion-label>{{ p.title }}</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-item
            [routerLink]="['/login']"
            routerDirection="root"
            routerLinkActive="router-link-active"
            lines="none"
            detail="false"
            *ngIf="user?.uid"
          >
            <ion-label> <span class="emoji">🔒</span> Login</ion-label>
          </ion-item>

          <ion-item
            lines="none"
            detail="false"
            routerDirection="root"
            [routerLink]="['/aboutus']"
            routerLinkActive="router-link-active"
          >
            <span class="emoji">
              ℹ️
            </span>
            <ion-label>About Us</ion-label></ion-item
          >

          <ion-item (click)="signOut()" *ngIf="!user?.uid">
            <ion-label> <span class="emoji">🔒</span> Sign Out</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
